import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Coaching from './Coaching';
import reportWebVitals from './reportWebVitals';

function currentPath() {
  return window.location.pathname.replace(/\/+$/, '') || '/';
}

function isCoachingHost() {
  const host = window.location.hostname.replace(/^www\./, '');
  return host === 'vaughngtocoaching.com' || host.endsWith('.vaughngtocoaching.com');
}

function isLocalCoachingPreview(path) {
  const host = window.location.hostname;
  return (host === 'localhost' || host === '127.0.0.1') && path === '/coaching';
}

function Root() {
  const [path, setPath] = useState(currentPath);

  useEffect(() => {
    const onChange = () => setPath(currentPath());
    window.addEventListener('popstate', onChange);
    return () => window.removeEventListener('popstate', onChange);
  }, []);

  if (isCoachingHost() || isLocalCoachingPreview(path)) {
    return <Coaching />;
  }
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

reportWebVitals();
